<template>
    <div class="gas">
        <!-- 最上面部分 -->
        <div class="gas-right--head">
            <router-link to="/gasManage" class>加油站</router-link>&nbsp;/&nbsp;
            <span>公众号自定义菜单</span>
        </div>
        <div class="gas-right--content">
            <div class="gas-mark clearfix">
                <div
                    class="flex"
                    v-if="list.length"
                    v-for="(item, index) in list"
                    :key="index"
                    @click="onOne(index)"
                >
                    <div class="item">{{item.name}}</div>
                    <div
                        class="item"
                        v-for="(e, i) in item.sub_button"
                        :key="i"
                        @click.stop="onTwo(i,index)"
                    >{{e.name}}</div>
                    <div
                        v-if="item.sub_button&&(item.sub_button.length<3 || item.url!='')"
                        class="item add"
                        @click.stop="onTwoAdd(index)"
                    >+</div>
                </div>
                <div v-if="list.length<3" class="item add" @click.stop="onOneAdd">+</div>
            </div>
            <div class="o-m-b-30" v-show="tabIndex != 0">
                <el-input v-model="name" placeholder="输入名称" @input="inputOne" style="width:264px;"></el-input>
                <el-select
                    v-model="selectVal"
                    placeholder="请选择"
                    @change="selectChange"
                    style="width:195px;"
                >
                    <el-option
                        v-for="item in selectList"
                        :key="item.val"
                        :label="item.name"
                        :value="item.val"
                    ></el-option>
                </el-select>
            </div>
            <div class="o-m-b-30" v-show="tabIndex != 0">
                <el-input v-model="url" placeholder="输入域名" @input="inputTwo" style="width:463px;"></el-input>
            </div>
            <el-button type="primary" round @click="onFix">确定</el-button>
            <el-button type="warning" round v-if="tabIndex != 0" @click="onDelete">删除</el-button>
        </div>
    </div>
</template>
<script>
import { getCustomMenu, updateCustomMenu } from "@/components/api/index.js";
export default {
    data() {
        return {
            tabIndex: 0, //当前选中的是一级还是二级
            oneIndex: null, //选中的一级index
            twoIndex: null, //选中的二级index
            name: "",
            url: "",
            list: [],
            selectList: [
                {
                    name: "自定义",
                    val: 0,
                },
                {
                    name: "一键加油",
                    url: `https://ydc.yichengshi.cn/gas/#/?shopId=${this.$route.query.shopId}`,
                    val: 1,
                },
                {
                    name: "个人中心",
                    url: `https://ydc.yichengshi.cn/gas/#/myInfo?shopId=${this.$route.query.shopId}`,
                    val: 2,
                },
                {
                    name: "油站导航",
                    url: `https://ydc.yichengshi.cn/gas/#/gasStationsList?shopId=${this.$route.query.shopId}`,
                    val: 3,
                },
                {
                    name: "消费记录",
                    url: `https://ydc.yichengshi.cn/gas/#/orderList?shopId=${this.$route.query.shopId}`,
                    val: 4,
                },
                {
                    name: "今日油价",
                    url: `https://ydc.yichengshi.cn/gas/#/gasPricesDetail?shopId=${this.$route.query.shopId}`,
                    val: 5,
                },
                {
                    name: "积分商城",
                    url: `https://ydc.yichengshi.cn/gas/#/scoreMall?shopId=${this.$route.query.shopId}`,
                    val: 6,
                },
            ],
            selectVal: 0,
        };
    },
    computed: {
    
    },
    created() {},
    mounted() {
        console.log();

        this.getCustomMenu();
    },
    methods: {
        onOne(i) {
            this.name = this.list[i].name;
            this.tabIndex = 1;
            this.oneIndex = i;
            this.twoIndex = null;
            this.url = this.list[this.oneIndex].url;
            this.selectFor();
        },
        onTwo(i, index) {
            this.tabIndex = 2;
            this.oneIndex = index;
            this.twoIndex = i;
            this.name = this.list[index].sub_button[i].name;
            this.url = this.list[this.oneIndex].sub_button[this.twoIndex].url;
            this.selectFor();
        },
        onOneAdd() {
            this.list.push({
                name: "",
                url: "",
                sub_button: [],
            });

            this.name = "";
            this.url = "";
            this.oneIndex = this.list.length - 1;
            this.tabIndex = 1;
            this.selectVal = 0;
        },
        onTwoAdd(i) {
            this.name = "";
            this.url = "";
            this.oneIndex = i;

            this.tabIndex = 2;
            this.list[i].sub_button.push({
                name: "",
                url: "http://",
                type: "view",
            });
            delete this.list[i].type;
            this.twoIndex = this.list[i].sub_button.length - 1;
            this.url = this.list[this.oneIndex].sub_button[this.twoIndex].url;
            this.selectVal = 0;
        },
        onDelete() {
            if (this.tabIndex == 1) {
                this.list[this.oneIndex].name = "";
                this.list.splice(this.oneIndex, 1);
            } else {
                this.list[this.oneIndex].sub_button.splice(this.twoIndex, 1);
            }

            this.name = "";
            this.url = "";
            this.tabIndex = 0;
            this.oneIndex = null;
            this.twoIndex = null;
        },
        inputOne(e) {
            if (this.tabIndex == 1) {
                this.list[this.oneIndex].name = e;
            } else {
                this.list[this.oneIndex].sub_button[this.twoIndex].name = e;
            }
        },
        inputTwo(e) {
            if (this.tabIndex == 1) {
                this.list[this.oneIndex].url = e;
                if (this.list[this.oneIndex].url == "") {
                    this.list[this.oneIndex].sub_button = [];
                    delete this.list[this.oneIndex].type;
                } else {
                    delete this.list[this.oneIndex].sub_button;
                    this.list[this.oneIndex].type = "view";
                }
            } else {
                this.list[this.oneIndex].sub_button[this.twoIndex].url = e;
            }
        },
        getCustomMenu() {
            getCustomMenu().then((res) => {
                let data = res.data;
                console.log(data);

                if (res.code == 1) {
                    if (JSON.stringify(data) == "{}" || !data.customMenu) {
                        this.list.push({
                            name: "",
                            url: "",
                            sub_button: [],
                            type: "view",
                        });
                    } else {
                        data = data.customMenu
                            ? JSON.parse(res.data.customMenu).button
                            : "";
                        this.list = data;
                    }
                }
            });
        },
        onFix() {
            let arr = { button: [] };
            arr.button = JSON.parse(JSON.stringify(this.list));
            for (var i = arr.button.length - 1; i >= 0; i--) {
                if (
                    arr.button[i].url &&
                    arr.button[i].url.indexOf("http") === -1
                ) {
                    arr.button[i].url = "https://" + arr.button[i].url;
                }
                if (arr.button[i].name == "") {
                    arr.button.splice(i, 1);
                }
            }
            console.log(arr, arr.button.length ? JSON.stringify(arr) : "");
            updateCustomMenu({
                customMenu: arr.button.length ? JSON.stringify(arr) : "",
            }).then((res) => {
                console.log(res);
                if (res.code == 1) {
                    this.$notify({
                        title: "成功",
                        message: "保存成功",
                        type: "success",
                        duration: 6000,
                    });
                    this.getCustomMenu();
                }
            });
        },
        selectChange(e) {
            if (e == 0) {
                this.name = "";
                this.url = "";
                this.inputOne("");
                this.inputTwo("");
            } else {
                this.name = this.selectList[e].name;
                this.url = this.selectList[e].url;
                this.inputOne(this.selectList[e].name);
                this.inputTwo(this.selectList[e].url);
            }

            return;

            if (e == 0) {
                this.name = "";
                this.url = "";
                this.inputTwo("");
            } else {
                this.name = this.selectList[e].name;
                this.url = this.selectList[e].url;
            }

            if (this.tabIndex == 1) {
                if (e == 0) {
                    this.list[this.oneIndex].name = "";
                    this.list[this.oneIndex].url = "";
                    return;
                }
                this.list[this.oneIndex].name = this.selectList[e].name;
                this.list[this.oneIndex].url = this.selectList[e].url;
                this.inputTwo(this.selectList[e].url);
            } else if (this.tabIndex == 2) {
                if (e == 0) {
                    this.list[this.oneIndex].sub_button[this.twoIndex].name =
                        "";
                    this.list[this.oneIndex].sub_button[this.twoIndex].url = "";
                    return;
                }
                this.list[this.oneIndex].sub_button[
                    this.twoIndex
                ].name = this.selectList[e].name;
                this.list[this.oneIndex].sub_button[
                    this.twoIndex
                ].url = this.selectList[e].url;
            }
        },
        selectFor() {
            let a = 0;
            for (let n = 0; n < this.selectList.length; n++) {
                if (this.selectList[n].name == this.name) {
                    a = n;
                }
            }
            this.selectVal = a;
        },
    },
};
</script>

<style lang="scss" scoped>
.gas {
    width: calc(100vw - 200px);
    height: calc(100vh);
    margin-left: 200px;
    min-width: 1340px;
    background-color: #f8f8f8;
    padding-top: 87px;
    box-sizing: border-box;
    padding-right: 25px;
    z-index: 9;
}
.gas-right--head {
    height: 66px;
    line-height: 66px;
    background-color: #fff;
    padding-left: 31px;
    font-weight: 400;
    display: inline-flex;
    align-items: center;
    width: 100%;
    box-sizing: border-box;
    position: fixed;
    top: 0;
    font-size: 14px;
    a {
        color: #333333;
    }
    span {
        color: #5f6165;
    }
}
.gas-right--content {
    padding: 80px 30px 40px 26px;
    // padding: 87px 25px 0 28px;
    width: 100%;
    box-sizing: border-box;
    background-color: #fff;
}
.gas-mark {
    display: flex;
    align-items: flex-end;
    margin-bottom: 30px;
    .flex {
        display: flex;
        flex-direction: column-reverse;
    }
    .item {
        width: 155px;
        height: 40px;
        line-height: 40px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(220, 223, 230, 1);
        border-radius: 0px 0px 0px 4px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(96, 98, 102, 1);
        text-align: center;
        cursor: pointer;
        box-sizing: border-box;
    }
    .add {
        width: 155px;
        height: 40px;
        line-height: 40px;
        font-weight: bold;
        color: #fff;
        font-size: 24px;
        background: rgba(64, 158, 255, 1);
        border-radius: 4px 0px 0px 0px;
    }
}
</style>





// WEBPACK FOOTER //
// src/components/page/gasAddMark.vue